// extracted by mini-css-extract-plugin
export default {"content":"BlockImage_content__oI08z","block":"BlockImage_block__7ONRd","image":"BlockImage_image__IVvcZ","text":"BlockImage_text__gBSUc","blockImage":"BlockImage_blockImage__yu4J3"};